import styled from "styled-components"

import CheckBox from "components/presenters/button/CheckBox"

export default function PaymentTermsAgree({ onCheck, isChecked }) {
  return (
    <CheckBoxBlock>
      <CheckBoxLabel htmlFor="payment-terms-agree">
        <CheckBox id="payment-terms-agree" onChange={onCheck} checked={isChecked} />
        결제 약관 전체 동의 (필수)
      </CheckBoxLabel>
      <TermsList>
        <TermsItem>주문상품, 주문정보 확인 및 구매 진행에 동의</TermsItem>
        <TermsItem>배송/교환/반품 정책</TermsItem>
        <TermsItem>개인정보 제 3자 정보 제공</TermsItem>
      </TermsList>
    </CheckBoxBlock>
  )
}

const CheckBoxBlock = styled.div`
  padding-top: calc(100vw * (25 / 375));
`

const CheckBoxLabel = styled.label`
  display: flex;
  align-items: center;
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (17 / 375));
  color: #121212;
`

const TermsList = styled.ul`
  margin-top: calc(100vw * (13 / 375));
  list-style: disc;
  padding-left: calc(100vw * (17 / 375));
`

const TermsItem = styled.li`
  font-size: calc(100vw * (12 / 375));
  font-weight: 500;
  line-height: calc(100vw * (16 / 375));
  color: #7f7f7f;
  margin-bottom: calc(100vw * (6 / 375));

  &:nth-last-child(1) {
    margin-bottom: 0;
  }
`
